// extracted by mini-css-extract-plugin
export default {"select":"AdminAemetMeasuresPage_select__Zbknr"};